var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 9.72006C18.79 9.72006 18.05 8.44006 18.95 6.87006C19.47 5.96006 19.16 4.80006 18.25 4.28006L16.52 3.29006C15.73 2.82006 14.71 3.10006 14.24 3.89006L14.13 4.08006C13.23 5.65006 11.75 5.65006 10.84 4.08006L10.73 3.89006C10.28 3.10006 9.26 2.82006 8.47 3.29006L6.74 4.28006C5.83 4.80006 5.52 5.97006 6.04 6.88006C6.95 8.44006 6.21 9.72006 4.4 9.72006C3.36 9.72006 2.5 10.5701 2.5 11.6201V13.3801C2.5 14.4201 3.35 15.2801 4.4 15.2801C6.21 15.2801 6.95 16.5601 6.04 18.1301C5.52 19.0401 5.83 20.2001 6.74 20.7201L8.47 21.7101C9.26 22.1801 10.28 21.9001 10.75 21.1101L10.86 20.9201C11.76 19.3501 13.24 19.3501 14.15 20.9201L14.26 21.1101C14.73 21.9001 15.75 22.1801 16.54 21.7101L18.27 20.7201C19.18 20.2001 19.49 19.0301 18.97 18.1301C18.06 16.5601 18.8 15.2801 20.61 15.2801C21.65 15.2801 22.51 14.4301 22.51 13.3801V11.6201C22.5 10.5801 21.65 9.72006 20.6 9.72006ZM12.5 15.7501C10.71 15.7501 9.25 14.2901 9.25 12.5001C9.25 10.7101 10.71 9.25006 12.5 9.25006C14.29 9.25006 15.75 10.7101 15.75 12.5001C15.75 14.2901 14.29 15.7501 12.5 15.7501Z",
    fill: "url(#paint0_linear_847_25420)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_847_25420",
    x1: 12.505,
    y1: 3.06116,
    x2: 12.505,
    y2: 21.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingColorIcon);
export default __webpack_public_path__ + "static/media/setting-color-icon.3553a3a762a761927acbca9e388f2ded.svg";
export { ForwardRef as ReactComponent };